import browserUtils from './browserUtils'

const outputUtils = {
  printFrame: null,
  print: function (content, type) {
    return new Promise((resolve, reject) => {
      if (window.Blob) {
        let blob = new Blob([content], {
          type: `text/${type}`
        })
        if (browserUtils.isIE()) {
          if (this.printFrame) {
            try {
              this.printFrame.contentDocument.write('')
              this.printFrame.contentDocument.clear()
            } catch (e) {}
            document.body.removeChild(this.printFrame)
          }
          this.printFrame = document.createElement('iframe')
          document.body.appendChild(this.printFrame)
          this.printFrame.contentDocument.write(content)
          this.printFrame.contentDocument.execCommand('print')
        } else {
          if (!this.printFrame) {
            this.printFrame = document.createElement('iframe')
            this.printFrame.onload = function (evnt) {
              if (evnt.target.src) {
                evnt.target.contentWindow.print()
              }
            }
            document.body.appendChild(this.printFrame)
          }
          this.printFrame.src = URL.createObjectURL(blob)
        }
        resolve()
      } else {
        reject(new Error('请使用最新浏览器进行操作'))
      }
    })
  },
  printHtml: function (content) {
    return this.print(content, 'html')
  },
  printArt: function (template, data) {
    return this.printHtml(template(Object.assign({
      baseURL: window.location.href.split('#')[0]
    }, data)))
  },
  download: function (content, type, filename) {
    return new Promise((resolve, reject) => {
      if (window.Blob) {
        let blob = new Blob([content], {
          type: `text/${type}`
        })
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, filename)
        } else {
          this.downloadUrl(URL.createObjectURL(blob), filename)
        }
        resolve()
      } else {
        reject(new Error('请使用最新浏览器进行操作'))
      }
    })
  },
  downloadUrl: function (url, filename, stopPropagation) {
    let linkElem = document.createElement('a')
    linkElem.target = '_blank'
    linkElem.download = filename
    linkElem.href = url
    if (stopPropagation) {
      linkElem.onclick = e => e.stopPropagation()
    }
    document.body.appendChild(linkElem)
    linkElem.click()
    document.body.removeChild(linkElem)
  }
}

export default outputUtils
